module.exports = __webpack_public_path__ + "static/media/Montserrat-Medium.4183bb3e.eot";